import React, { useState } from "react";
import { useForm } from "@formspree/react";

export const Contact = () => {
    const [submitted, setSubmitted] = useState(false);
    const [state, handleSubmit] = useForm("xdkojkkd");

    const handleManualSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        handleSubmit(event);
    };

    if (state.succeeded && !submitted) {
        setSubmitted(true);
    }

    return (
        <section className="contact text-bg-dark bg-gradient pt-5">
            <div className="container">
                <div className="row">
                    <div className="col-md-8 offset-md-2">
                        <div className="text-center mb-5">
                            <h4 className="text-uppercase fw-bold text-primary">
                                Contact
                            </h4>
                            <hr className="w-25 mx-auto" />
                            <h2 className="mb-4">I'd love to hear from you.</h2>
                            <p>
                                If you have any questions about Dragonshifty
                                Studios or if you'd like to work with me, please
                                contact me with the form below.
                            </p>
                        </div>
                        {submitted ? (
                            <div className="alert alert-success text-center">
                                Thank you! Your message has been sent.
                            </div>
                        ) : (
                            <form
                                name="contact"
                                method="POST"
                                onSubmit={handleManualSubmit}
                            >
                                <input
                                    type="hidden"
                                    name="form-name"
                                    value="contact"
                                />
                                <div className="mb-5">
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control bg-transparent border-top-0 border-start-0 border-end-0 rounded-0 border-muted text-white"
                                        placeholder="Name"
                                        required
                                    />
                                </div>
                                <div className="mb-5">
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control bg-transparent border-top-0 border-start-0 border-end-0 rounded-0 border-muted text-white"
                                        placeholder="Email"
                                        required
                                    />
                                </div>
                                <div className="mb-5">
                                    <textarea
                                        name="message"
                                        className="form-control bg-transparent border-top-0 border-start-0 border-end-0 rounded-0 border-muted text-white"
                                        placeholder="Message"
                                        required
                                    ></textarea>
                                </div>
                                <div className="mb-5 d-grid">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={state.submitting}
                                    >
                                        {state.submitting
                                            ? "Submitting..."
                                            : "Submit"}
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};
